import styled from 'styled-components';
import { CheckboxGroup } from './CheckboxGroup.styled';

export const SurroundingsGroup = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-items: center;
    row-gap: 25px;

    width: 640px;

    ${CheckboxGroup} {
        margin-bottom: 5px;
    }
`;
